export default {"src":"/login-app/[GIT_HASH]/_next/static/media/trending_up.c6d1f82c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};